import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  Link, containerQueryProps,
} from '@resy/ui-kitchen';
import { handleMktAnalytics } from '../../../AmexMarketingUtils/AmexUtils';
import {
  CTA_EVENT_NAME, AMEX_UTM_SOURCE, AMEX_DELTA_UTM_MEDIUM, AMEX_DELTA_UTM_EDITORIAL_CAMPAIGN,
} from '../../../AmexMarketingUtils/constants';
import './DeltaWifiEditorialCard.scss';

const DeltaWifiEditorialCard = (props) => {
  const {
    image, title, url, containerQuery: { md, lg, xl }, analyticsEvent,
  } = props;

  const hrefValue = {
    pathname: url,
    query: {
      utm_source: AMEX_UTM_SOURCE,
      utm_medium: AMEX_DELTA_UTM_MEDIUM,
      utm_campaign: AMEX_DELTA_UTM_EDITORIAL_CAMPAIGN,
    },
  };

  const extraParams = {
    action_name: 'Editorial Click',
    ...(title && { item_name: title }),
  };

  return (
    <div className="DeltaWifiEditorialCard">
      <Link
        className={cx('DeltaWifiEditorialCard', {
          'DeltaWifiEditorialCard--md': md,
          'DeltaWifiEditorialCard--lg': lg,
          'DeltaWifiEditorialCard--xl': xl,
        })}
        href={hrefValue}
        aria-label={title}
        tabIndex="-1"
        variant="article"
        onClick={() => handleMktAnalytics(analyticsEvent, CTA_EVENT_NAME, extraParams)}
      >
        <div
          className={cx('DeltaWifiEditorialCard__image', {
            'DeltaWifiEditorialCard__image--md': md,
            'DeltaWifiEditorialCard__image--lg': lg,
            'DeltaWifiEditorialCard__image--xl': xl,
          })}
          style={{
            backgroundImage: `url(${image})`,
          }}
        />
      </Link>

      <div className="DeltaWifiEditorialCard__content">
        <Link
          className="DeltaWifiEditorialCard__title"
          href={hrefValue}
          aria-label={title}
          variant="article"
          onClick={() => handleMktAnalytics(analyticsEvent, CTA_EVENT_NAME, extraParams)}
        >
          <h2
            className={cx('DeltaWifiEditorialCard__title skeleton', {
              'no-skeleton': !!title,
            })}
          >
            {title}
          </h2>
        </Link>
      </div>
    </div>

  );
};

DeltaWifiEditorialCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  containerQuery: containerQueryProps,
  analyticsEvent: PropTypes.func.isRequired,
};

DeltaWifiEditorialCard.defaultProps = {
  containerQuery: {},
};

export default DeltaWifiEditorialCard;
